import { EmailSenderService } from 'src/app/services/email-sender.service';
import { switchMap } from 'rxjs/operators';
import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { requireCheckboxesToBeCheckedValidator } from 'src/app/Modules/idms/core/atleastOneChecked.validator';
import { OrgType } from 'src/app/Modules/management/enums/organization-type';
import { AdUserValidationResp } from 'src/app/Modules/management/models/organization/adUserValidationResp.model';
import { AddB2CUser, B2CUser } from 'src/app/Modules/management/models/organization/fedratedOrganizationUser.model';
import { LicenseType } from 'src/app/Modules/management/models/organization/license-type.model';
import { OrganizationUserModel, UserLicense } from 'src/app/Modules/management/models/organization/organization-user.model';
import { Organization, profileContactModel, SecurityLevels } from 'src/app/Modules/management/models/organization/organization.model';
import { PermissionHierarchy } from 'src/app/Modules/management/models/organization/security-role-permission.model';
import { ManagementApiService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { Subscription } from 'rxjs';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { EmailType } from 'src/app/models/enums/email-type.enum';
import { EmailNewOrgAdd } from 'src/app/models/Emails.model';
import { User } from 'src/app/Modules/management/models/organization/user.model';

@Component({
    selector: 'app-organization-user-list',
    templateUrl: './organization-user-list.component.html',
    styleUrls: ['./organization-user-list.component.scss'],
})
export class OrganizationUserListComponent implements OnInit, OnDestroy {
    @Input() currentOrganizationId: string;
    @Input() activeOrganization: Organization;

    _securityRolesData: PermissionHierarchy[];
    selectedOptionUserType: string = null;
    addUserForm: UntypedFormGroup;
    userLicenseType: LicenseType[] = [];
    licenseType: string; //this is to display the license validity controls(like start date and end date and no of days)
    fetchUser: B2CUser;
    isAddButtonClicked = false;
    organizationUser: OrganizationUserModel;
    isB2CUser: boolean = false;
    isFederatedUser: boolean = false;
    userFormData = new FormData();
    isFederatedOrganization: boolean = false;
    isUserdetailsExist: boolean = false;
    organizationUserTypes: PermissionHierarchy[];
    orgType: number;
    isAddButton: boolean;
    currentUserStatus: AdUserValidationResp;
    dateSubscription: Subscription;
    emailSubscription: Subscription;
    fedOrgSubscription: Subscription;
    subscriptionList: Subscription[];
    minDate: Date;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private managementApiService: ManagementApiService,
        public ngbActiveModal: NgbActiveModal,
        private ngxUiLoaderService: NgxUiLoaderService,
        private organizationDataService: OrganizationDataService,
        private cd: ChangeDetectorRef,
        private customToastService: CustomToastService,
        private user_utlity: UserUtilityService,
        private emailSenderService: EmailSenderService
    ) {
        this.orgType = 0; // * by default organization is non-federated
        this.isAddButton = false;
        this.subscriptionList = [];
        this.minDate = new Date();
    }

    ngOnInit(): void {
        this.getUserRoleForDropdown();
        this.createUserFormControls();
        this.generalControllerForDisableForm(1); // * make the forma disable initially
        if (this.organizationDataService.userLicenseType.length) {
            this.userLicenseType = this.organizationDataService.getUserLicenseType().filter((item) => item.name != 'On Hold'); //Filtered for new user
        } else {
            this.getUserLicenseType();
        }
        this.handleLicenseTypeValidation();
        this.handleRequiredSubscription();
    }

    // * method to create user form controls
    createUserFormControls() {
        this.addUserForm = this.formBuilder.group({
            user_email: new UntypedFormControl('', [
                Validators.required,
                Validators.email,
                Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'),
            ]),
            user_first_name: new UntypedFormControl('', [Validators.required]),
            user_last_name: new UntypedFormControl('', Validators.required),
            user_type: new UntypedFormControl('', [Validators.required]),
            licenseGroup: new UntypedFormGroup(
                {
                    idms_license: new UntypedFormControl(false, []),
                    informate_license: new UntypedFormControl(false, []),
                },
                requireCheckboxesToBeCheckedValidator()
            ),
            license_type: new UntypedFormControl('', [Validators.required]),
            license_startDate: new UntypedFormControl(null, []),
            license_endDate: new UntypedFormControl(null, []),
            license_days: new UntypedFormControl('', []),
        });
    }

    // * api call to get the license types
    getUserLicenseType() {
        this.ngxUiLoaderService.start();
        this.managementApiService.getLicenseType().subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success === true) {
                    this.userLicenseType = res.response;
                    this.organizationDataService.setUserLicenseType(res.response);
                } else {
                    this.user_utlity.errorModelPopup(res.message);
                }
            },
            (err) => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    // * api call to get the user security roles
    getUserRoleForDropdown() {
        let organizationUserTypes = this.organizationDataService.filterSecurityRolesByLicense(
            this.organizationDataService.getUserSecurityRoles(),
            this.activeOrganization
        );
        this.organizationUserTypes = [...new Set(organizationUserTypes)];
    }

    // * helper method to get all the form controls value
    getFormControlValues() {
        let organizationUserData = new OrganizationUserModel();
        let userProfileContact = new profileContactModel();
        let userLicense = new UserLicense();
        let userLicenseType = new LicenseType();

        // setting up values for api payload
        organizationUserData.organisationID = this.currentOrganizationId;
        userProfileContact.email = this.addUserForm.get('user_email').value;
        userProfileContact.firstName = this.addUserForm.get('user_first_name').value;
        userProfileContact.lastName = this.addUserForm.get('user_last_name').value;
        userLicenseType.name = this.getLicenseTypeId(this.addUserForm.get('license_type').value);
        userLicenseType.licenseTypeId = this.getLicenseTypeId(this.addUserForm.get('license_type').value);
        if (
            this.addUserForm.get('license_type').value !== 'On Hold' &&
            this.addUserForm.get('license_type').value !== 'Perpetual' &&
            this.addUserForm.get('license_type').value !== 'Timed'
        ) {
            userLicense.startDate = this.addUserForm.get('license_startDate').value.toDateString();
            userLicense.endDate = this.setDate(new Date(userLicense.startDate));
        }
        userLicense.licenseType = userLicenseType;
        organizationUserData.securityRoleID = this.addUserForm.get('user_type').value;
        organizationUserData.profileContact = userProfileContact;
        organizationUserData.license = userLicense;
        return organizationUserData;
    }

    // * helper method to set the end date
    setDate(customDate: Date) {
        let date = new Date(customDate);
        date.setDate(date.getDate() + 365);
        return date.toDateString();
    }

    // * helper method to find the licenseType id
    getLicenseTypeId(licenseName: string): string {
        let licenseTypeId = '';
        this.userLicenseType.forEach((license) => {
            if (license.name === licenseName) {
                licenseTypeId = license.licenseTypeId;
            }
        });
        return licenseTypeId;
    }

    // * helper method to create api payload in the form of FormData
    createAddUserFormData(userData: OrganizationUserModel) {
        this.userFormData.append('user[OrganisationID]', userData.organisationID);
        this.userFormData.append('user[ProfileContact][Email]', userData.profileContact.email);
        this.userFormData.append('user[ProfileContact][FirstName]', userData.profileContact.firstName);
        this.userFormData.append('user[ProfileContact][LastName]', userData.profileContact.lastName);
        this.userFormData.append('user[License][LicenseTypeId]', userData.license.licenseType.licenseTypeId);
        this.userFormData.append('user[SecurityRoles][0]', userData.securityRoleID);
        if (this.addUserForm.get('licenseGroup').get('idms_license').value && this.addUserForm.get('licenseGroup').get('informate_license').value) {
            this.userFormData.append('user[License][InstanceTypeIndex]', 3 as unknown as Blob);
        } else if (this.addUserForm.get('licenseGroup').get('idms_license').value) {
            this.userFormData.append('user[License][InstanceTypeIndex]', 2 as unknown as Blob);
        } else if (this.addUserForm.get('licenseGroup').get('informate_license').value) {
            this.userFormData.append('user[License][InstanceTypeIndex]', 1 as unknown as Blob);
        }
        if (this.addUserForm.get('license_type').value !== 'On Hold' && this.addUserForm.get('license_type').value !== 'Perpetual') {
            if (this.addUserForm.get('license_type').value == 'Timed') {
                let startDate = new Date();
                this.userFormData.append('user[License][StartDate]', startDate.toDateString());
                let endDate = new Date(startDate.setDate(startDate.getDate() + this.addUserForm.get('license_days').value));
                this.userFormData.append('user[License][EndDate]', endDate.toDateString());
            } else {
                this.userFormData.append('user[License][EndDate]', userData.license.endDate);
                this.userFormData.append('user[License][StartDate]', userData.license.startDate);
            }
        }

        return this.userFormData;
    }

    // * helper method to create b2c user payload
    createB2CUser() {
        let b2cUser = new AddB2CUser();
        b2cUser.firstName = this.addUserForm.get('user_first_name').value;
        b2cUser.lastName = this.addUserForm.get('user_last_name').value;
        b2cUser.userEmail = this.addUserForm.get('user_email').value;
        b2cUser.organisationID = this.currentOrganizationId;
        return b2cUser;
    }

    // * method to add  the user into organization
    addUserIntoOrganization() {
        switch (this.orgType) {
            // * this is non-federated org
            case 0:
                if (this.currentUserStatus.infoCode == 2) {
                    let userInfo = this.getFormControlValues();
                    this.userFormData = new FormData();
                    this.createAddUserFormData(userInfo);
                    this.addUserToDataBaseApiCall(this.userFormData);
                } else if (this.currentUserStatus.infoCode == 3) {
                    this.addUserToDbAndB2CApiCall();
                }
                break;

            // * this is federated org
            case 1:
                if (this.currentUserStatus.infoCode == 2) {
                    let userInfo = this.getFormControlValues();
                    this.userFormData = new FormData();
                    this.createAddUserFormData(userInfo);
                    this.addUserToDataBaseApiCall(this.userFormData);
                } else if (this.currentUserStatus.infoCode == 3) {
                    this.addUserFederatedADAndDb();
                }
                break;
        }
    }

    // * api call to validate the user against ad
    validateUserAgainstAd() {
        let userEmail = this.addUserForm.get('user_email').value;
        this.currentUserStatus = null;
        // this.isAddButton = false;
        this.generalControllerForDisableForm(5);
        switch (this.orgType) {
            // * this is non-federated org
            case 0:
                if (userEmail) {
                    this.ngxUiLoaderService.start();
                    this.managementApiService.validateAzureADB2cUser(userEmail).subscribe(
                        (res) => {
                            this.ngxUiLoaderService.stop();
                            if (res.success === true) {
                                this.currentUserStatus = res.response;
                                this.validationHandlerForNonFedUser(res.response);
                            } else {
                                this.user_utlity.errorModelPopup(res.message);
                            }
                        },
                        (error) => {
                            this.ngxUiLoaderService.stop();
                        }
                    );
                }
                break;

            // * this is federated org
            case 1:
                if (userEmail && this.currentOrganizationId != null) {
                    this.ngxUiLoaderService.start();
                    this.managementApiService.validateFederatedAdB2cUser(this.currentOrganizationId, userEmail).subscribe(
                        (res) => {
                            this.ngxUiLoaderService.stop();
                            if (res.success === true) {
                                this.currentUserStatus = res.response;
                                this.validationHandlerForFederatedUser(res.response);
                            } else {
                                this.customToastService.errorToast(res.message, 'Error');
                            }
                        },
                        (error) => {
                            this.ngxUiLoaderService.stop();
                        }
                    );
                } else {
                    throw new Error('Please provide org ID');
                }
                break;
        }
    }

    // * validation handler for non-fed user
    // ! this comments will be removed once it is pass all QA Test cases
    validationHandlerForNonFedUser(inputData: AdUserValidationResp) {
        this.generalControllerForDisableForm(5);
        this.isAddButton = false;
        switch (inputData.infoCode) {
            case 1:
                // TODO here user is available in b2c as well as database so disable the add button and display the toast message
                // * set up the first name and last name of user and make it disable
                // * Add validation for disable the ADD Button in modal
                this.customToastService.infoToast('User is already a part of any organization!', 'Info');
                this.setValuesForName();
                this.generalControllerForDisableForm(1);
                this.isAddButton = true;
                break;
            case 2:
                // TODO here is available in only our B2C so will add user to db by making@ addOrganizationUser call & display toast message
                // * enable the ADD button
                this.customToastService.infoToast('User is available in our B2C add his license details!', 'Info');
                this.setValuesForName();
                this.generalControllerForDisableForm(3);
                break;
            case 3:
                // TODO here user is not available in our b2c as well as db so add user at both the location & display toast message
                this.customToastService.infoToast('User is not available in our B2C provide first and last name and add the license details!', 'Info');
                this.generalControllerForDisableForm(4);
                break;
        }
    }

    // * validation handler for fed-user
    // ! this comments will be removed once it is pass all QA Test cases
    validationHandlerForFederatedUser(inputData: AdUserValidationResp) {
        this.generalControllerForDisableForm(5);
        this.isAddButton = false;
        switch (inputData.infoCode) {
            case 0:
                // TODO here is is not available in customer's AD so we display the toast "Enter valid email"
                this.customToastService.infoToast('User not found please enter the valid email address!', 'Info');
                this.generalControllerForDisableForm(1);
                this.isAddButton = true;
                break;
            case 1:
                // TODO here user is available in b2c as well as database so disable the add button and display the toast message
                // * set up the first name and last name of user and make it disable
                // * Add validation for disable the ADD Button in modal
                this.customToastService.infoToast('User is available in our B2C & already part of any organization!', 'Info');
                this.generalControllerForDisableForm(1);
                this.setValuesForName();
                this.isAddButton = true;
                break;
            case 2:
                // TODO here is available in only our B2C so will add user to db by making @addOrganizationUser call & display toast message
                // * enable the ADD button
                this.customToastService.infoToast('User is available in our B2C add his license details!', 'Info');
                this.generalControllerForDisableForm(3);
                this.setValuesForName();
                break;
            case 3:
                // TODO here user is not available in our b2c as well as db so add user at both the location & display toast message
                this.customToastService.infoToast("User is not available in our B2C and database,Add user's license details!", 'Info');
                this.generalControllerForDisableForm(3);
                this.setValuesForName();
                break;
        }
    }

    // * api call to add the user in db
    // * @Params - orgType is passed because we have different kind of email templates for federated org and non-federated org
    addUserToDataBaseApiCall(userPayload: FormData) {
        this.ngxUiLoaderService.start();
        if (userPayload) {
            userPayload.append('user[UserID]', this.currentUserStatus.data.id);
            this.managementApiService.addOrganizationUser(userPayload).subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success === true) {
                        this.customToastService.successToast('User added successfully!', 'Success');
                        this.ngbActiveModal.close(true);
                        this.triggerEmail(res.response);
                    } else {
                        this.customToastService.errorToast(res.message);
                    }
                },
                (error) => {
                    // TODO error while adding USER
                    this.ngxUiLoaderService.stop();
                    this.customToastService.errorToast('Error while adding the user', 'Error');
                }
            );
        }
    }

    // * api call to add the user in db and b2c
    addUserToDbAndB2CApiCall() {
        let b2cUserPayload = this.createB2CUser();
        // * adding user into our b2c
        this.ngxUiLoaderService.start();
        if (b2cUserPayload) {
            this.managementApiService.addB2CUser(b2cUserPayload).subscribe(
                (res) => {
                    if (res.success === true) {
                        this.currentUserStatus.data = res.response;
                        // * adding user to our database
                        let userInfo = this.getFormControlValues();
                        this.userFormData = new FormData();
                        this.createAddUserFormData(userInfo);
                        this.addUserToDataBaseApiCall(this.userFormData);
                    } else {
                        this.customToastService.errorToast(`${res.message}`);
                    }
                },
                (error) => {
                    this.ngxUiLoaderService.stop();
                    this.customToastService.errorToast('Error while adding the user into B2C', 'Error');
                }
            );
        }
    }

    // * api call to add federated user into our b2c and db
    addUserFederatedADAndDb() {
        let b2cUserPayload = this.createB2CUser();
        // * adding user into our b2c
        this.ngxUiLoaderService.start();
        if (b2cUserPayload) {
            this.managementApiService.addFederatedUserTOB2C(b2cUserPayload).subscribe(
                (res) => {
                    if (res.success === true) {
                        this.currentUserStatus.data = res.response;
                        // * adding user to our database
                        let userInfo = this.getFormControlValues();
                        this.userFormData = new FormData();
                        this.createAddUserFormData(userInfo);
                        this.addUserToDataBaseApiCall(this.userFormData);
                    } else {
                        this.user_utlity.errorModelPopup(res.message);
                    }
                },
                (error) => {
                    this.ngxUiLoaderService.stop();
                    this.customToastService.errorToast('Error while adding the user into B2C', 'Error');
                }
            );
        }
    }

    // * helper method to handle the form validations
    generalControllerForDisableForm(index: number) {
        switch (index) {
            // * disable the whole form except email
            case 1:
                this.addUserForm.get('user_first_name').disable();
                this.addUserForm.get('user_last_name').disable();
                this.addUserForm.get('user_type').enable();
                this.addUserForm.get('licenseGroup').get('idms_license').enable();
                this.addUserForm.get('licenseGroup').get('informate_license').enable();
                this.addUserForm.get('license_type').enable();
                break;

            // * disable the first name and last name only
            case 2:
                this.addUserForm.get('user_first_name').disable();
                this.addUserForm.get('user_last_name').disable();
                break;

            // * enable the form except first name and last name
            case 3:
                this.addUserForm.get('user_first_name').disable();
                this.addUserForm.get('user_last_name').disable();
                this.addUserForm.get('user_type').enable();
                this.addUserForm.get('licenseGroup').get('idms_license').enable();
                this.addUserForm.get('licenseGroup').get('informate_license').enable();
                this.addUserForm.get('license_type').enable();
                this.cd.detectChanges();
                break;

            // * enable the whole form
            case 4:
                this.addUserForm.get('user_first_name').enable();
                this.addUserForm.get('user_last_name').enable();
                this.addUserForm.get('user_type').enable();
                this.addUserForm.get('licenseGroup').get('idms_license').enable();
                this.addUserForm.get('licenseGroup').get('informate_license').enable();
                this.addUserForm.get('license_type').enable();
                break;

            // * reset formControls values except first name and last name
            // case 4:
            //     this.addUserForm.get('user_type').reset();
            //     this.addUserForm.get('licenseGroup').get('idms_license').reset();
            //     this.addUserForm.get('licenseGroup').get('informate_license').reset();
            //     this.addUserForm.get('license_type').reset();
            //     break;

            // * reset whole formCOntrols except email
            case 5:
                this.addUserForm.get('user_first_name').reset();
                this.addUserForm.get('user_last_name').reset();
                this.addUserForm.get('user_type').reset();
                this.addUserForm.get('licenseGroup').get('idms_license').reset();
                this.addUserForm.get('licenseGroup').get('informate_license').reset();
                this.addUserForm.get('license_type').reset();
                this.addUserForm.get('license_startDate').reset();
                this.addUserForm.get('license_endDate').reset();
                this.licenseType = '';
                break;
        }
    }

    // * handler for adding/removing dynamic validators for license type fields
    handleLicenseTypeValidation() {
        this.addUserForm.get('license_type').valueChanges.subscribe((option: any) => {
            if (option === 'Renewal') {
                this.addUserForm.get('license_startDate').setValidators([Validators.required]);
                this.addUserForm.get('license_endDate').setValidators([Validators.required]);
                this.addUserForm.get('license_days').clearValidators();
                this.addUserForm.get('license_days').reset();
            } else if (option === 'Timed') {
                this.addUserForm.get('license_days').setValidators([Validators.required]);
                this.addUserForm.get('license_startDate').clearValidators();
                this.addUserForm.get('license_endDate').clearValidators();
                this.addUserForm.get('license_startDate').reset();
                this.addUserForm.get('license_endDate').reset();
            } else if (option === 'Perpetual' || option === 'On Hold') {
                this.addUserForm.get('license_startDate').clearValidators();
                this.addUserForm.get('license_endDate').clearValidators();
                this.addUserForm.get('license_days').clearValidators();
                this.addUserForm.get('license_startDate').reset();
                this.addUserForm.get('license_endDate').reset();
                this.addUserForm.get('license_days').reset();
            }
            this.addUserForm.get('license_startDate').updateValueAndValidity();
            this.addUserForm.get('license_endDate').updateValueAndValidity();
            this.addUserForm.get('license_days').updateValueAndValidity();
        });
    }

    // * helper method for initializing the required subscription
    handleRequiredSubscription() {
        this.fedOrgSubscription = this.organizationDataService.isFederatedOrganization$.subscribe((res: boolean) => {
            this.isFederatedOrganization = res;
            if (res) {
                this.orgType = OrgType.federated_org;
            }
        });

        this.dateSubscription = this.addUserForm.get('license_startDate').valueChanges.subscribe((startDate: Date) => {
            if (startDate) {
                this.addUserForm.get('license_endDate').setValue(new Date(this.setDate(startDate)));
            }
        });

        this.emailSubscription = this.addUserForm.get('user_email').valueChanges.subscribe((res) => {
            this.isAddButton = true;
            this.generalControllerForDisableForm(5);
            this.generalControllerForDisableForm(1);
        });

        this.subscriptionList.push(this.fedOrgSubscription);
        this.subscriptionList.push(this.dateSubscription);
        this.subscriptionList.push(this.emailSubscription);
    }

    // * api call to trigger an email to the user
    triggerEmail(userData: User) {
        // * using the same model because email has same parameters
        let payload = new EmailNewOrgAdd();
        payload.lastName = userData.profileContact?.lastName ? userData.profileContact?.lastName : '';
        payload.firstName = userData.profileContact?.firstName ? userData.profileContact?.firstName : '';
        payload.email = userData.profileContact?.email;
        payload.organizationName = userData.organisation.name;

        if (userData.profileContact?.email) {
            if (this.orgType == OrgType.federated_org) {
                this.emailSenderService.emailHandler(EmailType.NewUserAddedOrg, [userData.profileContact?.email], payload).subscribe(
                    (res) => {
                        // * mail sent to respective user
                    },
                    (err) => {}
                );
            } else {
                payload.password = this.currentUserStatus.data?.passwordProfile?.password;
                this.emailSenderService.emailHandler(EmailType.NewUserAddNonFedOrg, [userData.profileContact?.email], payload).subscribe(
                    (res) => {
                        // * mail sent to respective user
                    },
                    (err) => {}
                );
            }
        }
    }

    // * helper method to set up the first name and last name
    setValuesForName() {
        if (!this.currentUserStatus.data?.givenName || !this.currentUserStatus.data?.surname) {
            let nameArray = this.currentUserStatus.data.displayName.split(' ');
            if (nameArray.length > 1) {
                this.addUserForm.get('user_first_name').setValue(nameArray[0]);
                this.addUserForm.get('user_last_name').setValue(nameArray[1]);
            } else {
                this.addUserForm.get('user_first_name').setValue(nameArray[0]);
            }
        } else {
            this.addUserForm.get('user_first_name').setValue(this.currentUserStatus.data.givenName);
            this.addUserForm.get('user_last_name').setValue(this.currentUserStatus.data.surname);
        }
    }

    ngOnDestroy(): void {
        if (this.subscriptionList.length > 0) {
            this.subscriptionList.forEach((item) => {
                if (item) {
                    item.unsubscribe();
                }
            });
        }
    }
}
